module.exports = __webpack_public_path__ + "img/avv-info-en.cb269ecb.png";